import { logger } from '../utils/logger';

// Local storage service for managing MSAL-related keys
export const localStorageService = {
  // Clear only MSAL-related localStorage items, preserving other app data
  clearMsalItems: () => {
    try {
      logger.info('Clearing MSAL-related localStorage items...');

      const keysToDelete: string[] = [];

      // Remove jwtToken
      localStorage.removeItem('jwtToken');

      // Get MSAL account keys to identify related items
      const msalAccountKeys = localStorage.getItem('msal.account.keys');
      const msalAccountKeysArray: string[] = JSON.parse(
        msalAccountKeys || '[]',
      );

      // Scan localStorage for MSAL-related keys
      const allKeys = Object.keys(localStorage);
      for (const key of allKeys) {
        if (key) {
          // Direct MSAL keys
          if (key.startsWith('msal')) {
            keysToDelete.push(key);
            continue;
          }

          if (key.startsWith('server-telemetry')) {
            keysToDelete.push(key);
            continue;
          }

          // Account-related keys
          const result = msalAccountKeysArray.find((msalAccountKey) => {
            const tokens = msalAccountKey.split('.');
            return key.startsWith(tokens[0]);
          });
          if (result) {
            keysToDelete.push(key);
          }
        }
      }

      // Remove all identified MSAL keys
      keysToDelete.forEach((key) => {
        localStorage.removeItem(key);
      });

      logger.info(
        `Cleared ${keysToDelete.length + 1} MSAL-related localStorage items`,
      );
    } catch (error) {
      logger.error(
        'Error clearing MSAL localStorage items: ' +
          (error instanceof Error ? error.message : String(error)),
      );
    }
  },
};
